import React from 'react';
import { useSelector } from 'react-redux';
import { Size, SizeableText, Typography } from 'fronton-react';
import { DynamicPicture } from 'common/components';
import { selectIsSmallScreen } from 'store/pageStore';
import { selectPageModelTitle } from 'store/pageModel';

import { mainInfoImgSizes } from 'data';
import { ImgWrapperStyles, MainInfoWrapper, TextWrapper } from './styles';

type MainInfoProps = {
	title: string;
	basePhotoUrl: string;
	additionalText: string;
};

export const MainInfo = ({ title, basePhotoUrl, additionalText }: MainInfoProps) => {
	const pageTitle = useSelector(selectPageModelTitle);
	const isSmallScreen = useSelector(selectIsSmallScreen);
	const titleVariant = isSmallScreen ? 'h1' : 'display';
	const subtitleProps = isSmallScreen
		? { variant: 'm' as SizeableText, size: 'body_short' as Size }
		: { variant: 'h3' as SizeableText, size: '' as Size };

	return (
		<MainInfoWrapper>
			<TextWrapper>
				<Typography variant={titleVariant} as="h1" data-qa="main-info-title">
					{title}
				</Typography>
				<Typography {...subtitleProps} data-qa="main-info-additional-text">
					{additionalText}
				</Typography>
			</TextWrapper>
			<DynamicPicture
				pictureCN={ImgWrapperStyles}
				baseUrl={basePhotoUrl}
				sizes={mainInfoImgSizes}
				altText={pageTitle}
			/>
		</MainInfoWrapper>
	);
};
